import { DynamicForm } from '../../DynamicForm';
import { SettingItemList } from '../../SettingItemList';
import { useCreateOperator } from '../../../../../contexts/CreateOperatorContext';
import React from 'react';
import { Transport } from './Transport';

export const Transports = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  const streamsInputProps = { type: 'number', min: 0, max: 30 };

  const handleRemove = (transportIndex: number) => {
    updateOperator(
      'transportTypes',
      (operator.transportTypes ?? []).filter(
        (value, index) => index !== transportIndex
      )
    );
  };

  const handleSave = (item: CreateTransportType, transportIndex: number) => {
    updateOperator(
      'transportTypes',
      (operator.transportTypes ?? []).map((value, index) => {
        if (index === transportIndex) return item;
        return value;
      })
    );
  };

  return (
    <div className={classes.container}>
      <DynamicForm<CreateTransportType>
        defaultForm={{
          active: true,
          name: '',
          ingressHD: 0,
          ingressSD: 0,
          wanHD: 0,
          wanSD: 0,
        }}
        inputs={[
          {
            order: 0,
            rowInputs: [
              {
                props: {
                  name: 'name',
                  label: 'Name',
                  value: (values) => values.name,
                  required: false, // TODO: Disabling for now, Original setting: true,
                },
              },
            ],
          },
          {
            order: 1,
            rowInputs: [
              {
                props: {
                  name: 'ingressHD',
                  label: 'Ingress HD',
                  required: false, // TODO: Disabling for now, Original setting: true,
                  value: (values) => values.ingressHD,
                  inputProps: streamsInputProps,
                },
              },
              {
                props: {
                  name: 'ingressSD',
                  label: 'Ingress SD',
                  required: false, // TODO: Disabling for now, Original setting: true,
                  value: (values) => values.ingressSD,
                  inputProps: streamsInputProps,
                },
              },
              {
                props: {
                  name: 'wanHD',
                  label: 'WAN HD',
                  required: false, // TODO: Disabling for now, Original setting: true,
                  value: (values) => values.wanHD,
                  inputProps: streamsInputProps,
                },
              },
              {
                props: {
                  name: 'wanSD',
                  label: 'WAN SD',
                  required: false, // TODO: Disabling for now, Original setting: true,
                  value: (values) => values.wanSD,
                  inputProps: streamsInputProps,
                },
              },
            ],
          },
        ]}
        submitButton={{ text: 'Add Transport' }}
        onSubmit={(values) =>
          updateOperator('transportTypes', [
            values,
            ...(operator.transportTypes ?? []),
          ])
        }
        validation={(values) => values.name !== ''}
      />
      <SettingItemList<CreateTransportType>
        items={operator.transportTypes ?? []}
        name="Transports"
        renderRow={(item, index) => (
          <Transport
            index={index}
            transport={item}
            onRemove={handleRemove}
            onSave={handleSave}
          />
        )}
      />
    </div>
  );
};

const useStyles = () => ({
  container: 'flex flex-col gap-4 items-center',
});
